/**
 * Shared Subject Configuration
 * 
 * Defines the canonical list of subjects used throughout the application.
 * This matches the backend Teacher model enum values.
 */

export interface Subject {
  value: string;
  label: string;
  description?: string;
}

export const SUBJECTS: Subject[] = [
  { value: 'ELA', label: 'English Language Arts & Reading', description: 'Reading, writing, grammar, literature' },
  { value: 'Math', label: 'Mathematics', description: 'Arithmetic, algebra, geometry, statistics' },
];

/**
 * Get subject by value
 */
export function getSubjectByValue(value: string): Subject | undefined {
  return SUBJECTS.find(s => s.value === value);
}

/**
 * Get subject label by value
 */
export function getSubjectLabel(value: string): string {
  return getSubjectByValue(value)?.label || value;
}

/**
 * Get all subject values
 */
export function getSubjectValues(): string[] {
  return SUBJECTS.map(s => s.value);
}

/**
 * Default primary subject
 */
export const DEFAULT_PRIMARY_SUBJECT = 'ELA';

